var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 54,
    viewBox: "0 0 42 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_650_6234)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4289 15.7143C21.2855 15.7143 21.1427 15.7161 21.0002 15.7197C11.9673 15.947 4.71456 23.3408 4.71456 32.4286C4.71456 41.6596 12.1978 49.1429 21.4289 49.1429C30.6599 49.1429 38.1431 41.6596 38.1431 32.4286C38.1431 23.3408 30.8904 15.947 21.8574 15.7197C21.715 15.7161 21.5721 15.7143 21.4289 15.7143ZM3.85742 32.4286C3.85742 22.7241 11.7244 14.8571 21.4289 14.8571C31.1333 14.8571 39.0003 22.7241 39.0003 32.4286C39.0003 42.133 31.1333 50 21.4289 50C11.7244 50 3.85742 42.133 3.85742 32.4286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0003 32.4286L21.0002 15.7197L21.0002 15.2857H21.8574L21.8574 15.7197L21.8574 32.4286L21.0003 32.4286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5717 11.4286V2L18.6095 2L24.0262 9.61879L23.5579 9.66942V2H24.8108V11.4286H23.7731L18.3817 3.75916L18.812 3.70853V11.4286H17.5717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_b_650_6234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 15.7197C11.9675 15.9471 4.71484 23.3409 4.71484 32.4286C4.71484 41.6597 12.1981 49.1429 21.4291 49.1429C30.6602 49.1429 38.1434 41.6597 38.1434 32.4286C38.1434 23.3408 30.8907 15.947 21.8576 15.7197L21.8577 32.4286L21.0006 32.4286L21.0005 15.7197Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_650_6234",
    x: 0.857422,
    y: 0,
    width: 41.1426,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_650_6234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_650_6234",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_650_6234",
    x: -9.28516,
    y: 1.71973,
    width: 61.4287,
    height: 61.4233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_650_6234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_650_6234",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.d05e362c724d46dc94d3b4b60656a005.svg";
export { ForwardRef as ReactComponent };